export default "__VITE_ASSET__51dcd6c3__"